import React, { ReactNode, useContext } from 'react';

import { motion } from 'framer-motion';
import { generatePath, NavLink, useParams } from 'react-router-dom';

import { AuthContext } from '@/core/auth/AuthContext';
import routes from '@/routes';

export type UserPermissionTab = 'permissions' | 'teams';

export function UserPermissionsTabs () {
  const { hasCoreAccess } = useContext(AuthContext);
  const { userId, tab } = useParams() as { userId: string, tab?: UserPermissionTab };

  return (
    <div className="flex -ml-4">
      <Tab
        to={generatePath(routes.users.permissions, { userId, tab: 'permissions' })}
        isActive={tab === undefined || tab === 'permissions'}
      >
        Permissions
      </Tab>
      {hasCoreAccess && (
        <Tab
          to={generatePath(routes.users.permissions, { userId, tab: 'teams' })}
          isActive={tab === 'teams'}
        >
          Teams
        </Tab>
      )}
    </div>
  );
}

type TabProps = {
  to: string;
  isActive: boolean;
  children: ReactNode;
}
function Tab (props: TabProps) {
  const { children, isActive, ...rest } = props;

  return (
    <NavLink replace className="px-4" {...rest}>
      <div className={`py-3 px-0.5 ${isActive ? 'font-medium text-blue-900' : 'font-normal'}`}>
        { children }
      </div>
      {isActive && (
        <motion.div
          initial={false}
          layoutId="user-permissions-tab-underline"
          className="border-b border-blue-600"
        />
      )}
    </NavLink>
  );
}
